var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8695 20.4817L35.8695 20.4817L3.28546 2.05787C2.55216 1.64324 1.64404 2.17303 1.64404 3.01541L1.64404 39.8631C1.64404 40.7055 2.55217 41.2353 3.28546 40.8206L35.8695 22.3968C35.8695 22.3968 35.8695 22.3968 35.8695 22.3968C36.6143 21.9757 36.6142 20.9028 35.8695 20.4817ZM35.3773 21.3522L35.378 21.3509L35.3773 21.3522Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayWhite);
export default __webpack_public_path__ + "static/media/IconPlayWhite.3afd6bda3dc193c216114776421623e4.svg";
export { ForwardRef as ReactComponent };